import React, { useEffect, useMemo, useState } from 'react';
import Icon from '../Icon/Icon';
import styles from './BackgroundMusicEditor.module.scss';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

const SingleTrack = ({
  track,
  selectedMusic,
  currentVideoPart,
  playerPlayedMusic,
  previewPlayedMusic,
  musicVolume,
  videoVolume,
  chooseBackgroundMusic,
  handlePreviewPlayedMusic,
  onBackgroundMusicChange,
}) => {
  const [duration, setDuration] = useState('00:00');

  const { t } = useTranslation();

  const audio = useMemo(() => new Audio(track.path), [track]);

  useEffect(() => {
    const getDuration = () => {
      if (audio.duration) {
        const minutes = Math.floor(Math.round(audio.duration) / 60);
        const seconds = Math.round(audio.duration) - minutes * 60;

        const formatMinutes = minutes < 10 ? `0${minutes}` : minutes;
        const formatSeconds = seconds < 10 ? `0${seconds}` : seconds;
        setDuration(`${formatMinutes}:${formatSeconds}`);
      }
    };

    audio.addEventListener('loadedmetadata', getDuration);

    return () => {
      audio.pause();
      handlePreviewPlayedMusic(null);
      audio.removeEventListener('loadedmetadata', getDuration);
    };
  }, []);

  useEffect(() => {
    if (previewPlayedMusic === track.id) {
      audio.play();
      return;
    }

    audio.pause();
  }, [previewPlayedMusic]);

  useEffect(() => {
    if (audio) {
      audio.volume = musicVolume / 100;
    }
  }, [musicVolume]);

  const playPauseMusic = () => {
    if (previewPlayedMusic === track.id) {
      handlePreviewPlayedMusic(null);
      return;
    }

    handlePreviewPlayedMusic(track.id);
  };

  const handleSelectMusic = () => {
    chooseBackgroundMusic(track);
    onBackgroundMusicChange({
      sceneIndex: Number(currentVideoPart),
      newMusic: track,
      musicVolume: musicVolume / 100,
      videoVolume: videoVolume / 100,
      isApplyAllTrackEnabled: false,
      isApplyAllVolumeEnabled: false,
      isTemporaryAction: true,
    });
  };

  useEffect(() => {
    if (audio && selectedMusic?.id === previewPlayedMusic) {
      audio.currentTime = 0;
    }
  }, [selectedMusic]);

  return (
    <div
      className={cx(styles.musicContainer, { [styles.musicContainerSelected]: selectedMusic?.id === track.id })}
      onClick={handleSelectMusic}
    >
      <div className={styles.imageContainer}>
        <img src={track.logo_url} className={styles.image} alt={t('clip_organizer.logo_button')} />
        <Icon
          src={previewPlayedMusic === track.id ? 'musicPause' : 'musicPlay'}
          className={styles.actionIcon}
          verticalAlign="middle"
          onClick={playPauseMusic}
        />
      </div>
      <div className={styles.musicInfoContainer}>
        <span className={cx(styles.musicName, { [styles.musicNamePlayed]: playerPlayedMusic === track.id })}>{track.title}</span>
        {playerPlayedMusic === track.id || previewPlayedMusic === track.id ? (
          <div>
            <Icon src="musicWaveform" className={styles.waveformIcon} verticalAlign="middle" />
          </div>
        ) : (
          <span className={styles.musicDuration}>{duration}</span>
        )}
      </div>
    </div>
  );
};

export default SingleTrack;
